import { Component } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { IngredientsServices } from '../../../ingredients/services';
import { getCurrencySymbol } from '@angular/common';
import { ProductsServices } from '../../../products/services';
import { DeliberyNoteServices } from '../../../delibery_note/services';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'create-ingredient',
  templateUrl: 'create-ingredient.html',
})
export class CompCreateIngredientPage {
  name: number;
  allergens = [
    {
      name: this.translate.instant('general-allergens-altramueces'),
      src: './assets/icons_100/tramusos_100.png',
      uid: '2L9I1OFi0MttudVUajCy',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-apio'),
      src: './assets/icons_100/api_100.png',
      uid: 'G3bZpwrVP9bJvlOHT6XE',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-moluscos'),
      src: './assets/icons_100/molusc_100.png',
      uid: 'l1ojIaGuVlnyWjFD6WNQ',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-sesamo'),
      src: './assets/icons_100/sesam_100.png',
      uid: 'e8v2RnYzGWTH1CboyCR7',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-gluten'),
      src: './assets/icons_100/gluten_100.png',
      uid: '50bkEzjuWbQGCB7IjrEf',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-pescado'),
      src: './assets/icons_100/peix_100.png',
      uid: 'H4W23Lv4XHx4qpZCEbYN',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-dioxido-azufre-sulfitos'),
      src: './assets/icons_100/sulfits_100.png',
      uid: 'YGkIQKw7yOfwtHq95aly',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-mostaza'),
      src: './assets/icons_100/mostassa_100.png',
      uid: 'hPrDu9pjQmqXBnoxBfet',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-crustaceos'),
      src: './assets/icons_100/crustacis_100.png',
      uid: '4VuKpxSZoGRzvNqEdIlu',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-lactosa'),
      src: './assets/icons_100/lactic_100.png',
      uid: 'Io13IxX1i5BnOpjoyZBF',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-huevo'),
      src: './assets/icons_100/ou_100.png',
      uid: '1SlpPqFfsmjec4ZnwK45',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-soja'),
      src: './assets/icons_100/soja_100.png',
      uid: 'JV8kqxMaSd1Q61cwzU9x',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-frutos-secos'),
      src: './assets/icons_100/fruitsec_100.png',
      uid: '4sKpCjitEY6sV3BhwdLq',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-cacahuetes'),
      src: './assets/icons_100/cacauet_100.png',
      uid: 'TRku0ZmxtpB3M73D8wlD',
      active: false
    },
    //indicators
    {
      name: this.translate.instant('general-indicators-vegano'),
      src: './assets/icons_100/vega_100.png',
      uid: 'WBDYCZPjlBWlXG772MLZ',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-vegetariano'),
      src: './assets/icons_100/vegetaria_100.png',
      uid: 'VxAwcxVQu7ZytAunh4pK',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-ecologico'),
      src: './assets/icons_100/eco_100.png',
      uid: 'axhqvt8l5LAG1jba2Heq',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-mediterraneo'),
      src: './assets/icons_100/mediterrani.png',
      uid: 'qOJouJQSVIEFLGdEkwRs',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-kosher'),
      src: './assets/icons_100/kosher_100.png',
      uid: 'ecE19RgQX1ze3CHY1XJi',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-cafeina'),
      src: './assets/icons_100/cafeina_100.png',
      uid: 'mGYwKe2JYwTICu7N7sC6',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-sin-azucar'),
      src: './assets/icons_100/sensesucre.png',
      uid: 'QVZO1ivcXi8gQp5o8XZf',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-stevia'),
      src: './assets/icons_100/stevia.png',
      uid: 'WMZCNDQNjlICEQ1CZzbF',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-halal'),
      src: './assets/icons_100/halal_100.png',
      uid: 'q05pas64NVItzqNNq1Nb',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-picante-suave'),
      src: './assets/icons_100/picant1.png',
      uid: 'PAhaRzeD1Fc8Eh9HurEU',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-picante'),
      src: './assets/icons_100/picant2.png',
      uid: 'SDwqJGfd8tGgWVjQnlHK',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-muy-picante'),
      src: './assets/icons_100/picant3.png',
      uid: 'kbTVLXJAOEPY4PNSgA1D',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-km0'),
      src: './assets/icons_100/km0.png',
      uid: 'FHdPZ4t2S4PjB0IlCnC5',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-comida-rapida'),
      src: './assets/icons_100/rapid.png',
      uid: 'NL0JHSeK2E4ZA9yLvzAB',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-recomendado'),
      src: './assets/icons_100/recomenat.png',
      uid: 'juWdKnYZliS2eNez9Geo',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-cerdo'),
      src: './assets/icons_100/porc_100.png',
      uid: 'jjVvcvGn3gLcMqXy4wKX',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-maiz'),
      src: './assets/icons_100/bmoro_100.png',
      uid: 'SGflJYVDgHRjeItCdim2',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-setas'),
      src: './assets/icons_100/bolets_100.png',
      uid: '6QYpvI63JK4XDqsz1995',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-alcohol'),
      src: './assets/icons_100/alcohol_100.png',
      uid: '04rgCKokhvB0BuwdWet5',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-infantil'),
      src: './assets/icons_100/infantil_100.png',
      uid: 'x0gEJ4cFaVKLaQwfybrQ',
      active: false
    }
  ];
  origin: string;
  measurement: string = 'kg';
  price_static: number = 0;
  currency: string = '';

  constructor(public ingredientServices: IngredientsServices,
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    private toastCtrl: ToastController,
    public navParams: NavParams,
    public analyticsServices: AnalyticsServices,
    public productsServices: ProductsServices,
    public deliberyNoteServices: DeliberyNoteServices) {
    this.origin = this.navParams.get('origin');
    this.currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  saveElement() {
    //Comprovamos que tenga precio y nombre
    if (this.name) {
      //Creamos el plato y guardamos en bbdd
      this.insertIngredient();
      //Lo añadimos a la array de platos seleccionados
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  activeAllergen(allergen) {
    allergen.active = !allergen.active;
  }

  allergensCss(active) {
    if (active) {
      let cssClasses = {
        'allergenSelected': true,
        'mr-1': true,
        'mb-2': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'allergenSelected': false,
        'mr-1': true,
        'mb-2': true,
      }
      return cssClasses;
    }
  }

  insertIngredient() {
    let active_allergens = this.allergens.filter(x => x.active == true);
    let _allergens = [];
    active_allergens.forEach(allergen => {
      _allergens.push(allergen.uid);
    });
    let _ingredient = {
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'allergens': _allergens,
      'name': this.name,
      'measurement': this.measurement,
      'stock': 0,
      'stock_alert': 0,
      'stock_max': 0,
      'sub_recipe': false,
      'tags': [],
      'tags_static': '',
      'price_static': this.price_static,
      'provider_static': this.translate.instant('general-sin-proveedor'),
      'providers': [{
        default: true,
        name_static: this.translate.instant('general-sin-proveedor'),
        price_static: this.price_static,
        pricetotal_static: this.price_static,
        tax_static: 4,
        uid: this.globals.no_provider.UID,
        updated_at: new Date()
      }],
      'created_at': new Date(),
      'updated_at': new Date(),
    };
    this.ingredientServices.afs.collection('ingredients').add(_ingredient).then(doc => {
      this.globals.GAtrackView('Ingredients', 'Ingredients - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Ingredients', this.name);
      this.analyticsServices.trackingExpStock('create_ingredient', this.globals.tracking_exp['create_ingredient'], doc.id);
      //
      if (this.origin == 'dish') {
        this.insertToFoodcost(_ingredient, doc.id);
        this.close();
      } else if (this.origin == 'product') {
        this.insertToFoodcostProduct(_ingredient, doc.id);
        this.close();
      } else if (this.origin === 'delibery-note') {
        this.insertToDeliberyNote(_ingredient, doc.id);
        this.close();
      } else if (this.origin == 'variations') {
        this.selectToCreateVariation(_ingredient, doc.id);
      } else {
        this.insertToFoodcostIngredient(_ingredient, doc.id);
        this.close();
      }
    });
  }

  insertToFoodcost(element, element_uid) {
    element.UID = element_uid;
    //Funcion que añadir al array de platos seleccionados para el menu
    var _array = Array();
    _array.push(element_uid); //UID
    _array.push(element.name); //Name
    if (element.allergens == undefined) {
      element.allergens = [];
      _array.push(element.allergens);
    } else {
      _array.push(element.allergens);
    }
    if (element.sub_recipe) {
      _array.push(this.ingredientServices.returnPricePerMeasurement(element.price_static, element.real_weight));
    } else {
      _array.push(element.price_static);
    }
    _array.push(element.measurement); //Measurement
    _array.push(0); //Quantity
    _array.push(0); //Waste
    if (element.sub_recipe) {
      _array.push(this.translate.instant('general-sin-proveedor')); //Provider static
    } else {
      _array.push(element.provider_static); //Provider static
    }
    _array.push(0); //Cantidad bruta
    _array.push(0); //Precio
    _array.push('ingredient');

    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-ingrediente') + ' ' + element.name + ' ' + this.translate.instant('instant-anadido-correctemente'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
    //Hacemos push al listado de elementos seleccionados
    this.ingredientServices.foodcost_array_tmp.push(_array);
    this.ingredientServices.foodcost_array_tmp = [...this.ingredientServices.foodcost_array_tmp];
    //Hacemos push al listado de todos los elementos
    this.ingredientServices.ingredients_array.push(element);
    this.ingredientServices.ingredients_array = [...this.ingredientServices.ingredients_array];
  }

  insertToFoodcostProduct(element, element_uid) {
    element.UID = element_uid;
    //Funcion que añadir al array de platos seleccionados para el menu
    var _array = Array();
    _array.push(element_uid);
    _array.push(element.name);
    _array.push(element.measurement);
    _array.push(element.providers);
    _array.push(element.tax);
    _array.push(element.price_static);
    _array.push(element.provider_static);
    _array.push(element.tags);
    if (element.allergens == undefined) {
      element.allergens = [];
      _array.push(element.allergens);
    } else {
      _array.push(element.allergens);
    }
    _array.push(element.stock_alert);
    _array.push(element.stock);
    _array.push(element.sub_recipe);
    _array.push(0);//cantidad
    _array.push(0);//cantidad bruta
    _array.push(0);//merma
    _array.push(0);//preu final
    _array.push(0);//total
    _array.push(element.foodcost);
    _array.push(element.real_weight);
    _array.push('');
    _array.push('');
    _array.push('');
    _array.push('');
    _array.push('ingredient');

    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-ingrediente') + ' ' + element.name + ' ' + this.translate.instant('instant-anadido-correctemente'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
    //Hacemos push al listado de elementos seleccionados
    this.productsServices.prodings_array_tmp.push(_array);
    this.productsServices.prodings_array_tmp = [...this.productsServices.prodings_array_tmp];
    //Hacemos push al listado de todos los elementos
    this.ingredientServices.ingredients_array.push(element);
    this.ingredientServices.ingredients_array = [...this.ingredientServices.ingredients_array];
  }

  insertToFoodcostIngredient(element, element_uid) {
    element.UID = element_uid;
    //Funcion que añadir al array de platos seleccionados para el menu
    var _array = Array();
    _array.push(element.UID);
    _array.push(element.name);
    _array.push(element.measurement);
    _array.push(element.providers);
    _array.push(element.tax);
    _array.push(element.price_static);
    _array.push(element.provider_static);
    _array.push(element.tags);
    if (element.allergens == undefined) {
      element.allergens = [];
      _array.push(element.allergens);
    } else {
      _array.push(element.allergens);
    }
    _array.push(element.stock_alert);
    _array.push(element.stock);
    _array.push(element.sub_recipe);
    _array.push(0);//cantidad
    _array.push(0);//cantidad bruta
    _array.push(0);//merma
    _array.push(0);//preu final
    _array.push(0);//total
    _array.push(element.foodcost);
    _array.push(element.real_weight);
    _array.push('ingredient');

    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-ingrediente') + ' ' + element.name + ' ' + this.translate.instant('instant-anadido-correctemente'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
    //Hacemos push al listado de elementos seleccionados
    this.ingredientServices.ingredients_array_tmp.push(_array);
    this.ingredientServices.ingredients_array_tmp = [...this.ingredientServices.ingredients_array_tmp];
    //Hacemos push al listado de todos los elementos
    this.ingredientServices.ingredients_array.push(element);
    this.ingredientServices.ingredients_array = [...this.ingredientServices.ingredients_array];
  }

  insertToDeliberyNote(element, element_uid) {
    element.UID = element_uid;
    //
    var _array = Array();
    _array.push(element.UID);
    _array.push(element.name);
    _array.push('ingredient');
    _array.push(element.price_static);
    _array.push(element.measurement);
    _array.push(element.tax || this.globals.RESTAURANT_TAX);
    _array.push(0);
    _array.push(0);
    _array.push(0);
    _array.push(element.price_static);
    _array.push(0);
    _array.push("");
    _array.push("discount_percentage");
    this.deliberyNoteServices.prodings_array_tmp.push(_array);
    this.deliberyNoteServices.prodings_array_tmp = [...this.deliberyNoteServices.prodings_array_tmp];
    this.globals.launchToast(this.translate.instant('general-ingrediente') + ' ' + element.name + ' ' + this.translate.instant('instant-anadido-correctemente'), 3000, 'bottom');
  }

  selectToCreateVariation(element, element_uid) {
    element.UID = element_uid;
    this.viewCtrl.dismiss(element);
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/popups/create-ingredient/create-ingredient.ts